import type { Form_IForm } from './Form.types'
import { IDB_formsWrite } from '../IDB/IDB.table.form'
import { IDB_locationsReadAll } from '../IDB/IDB.table.location'

/**
 * Filter out locations that are not in our ownership
 * See https://code.zaptic.com/zaptic/zaptic/issues/3559#note_86394
 * Hopefully server will filter out in future
 */
export async function Form_sync(forms: Form_IForm[]) {
    if (forms == null) return

    const locations = await IDB_locationsReadAll()
    const locationIds = new Set(locations.map((location) => location.id))

    forms = forms.map((form) => ({
        ...form,
        locations: form.locations.filter((locationId) => locationIds.has(locationId)),
    }))

    return IDB_formsWrite((forms as any) || [])
}
